import { render, staticRenderFns } from "./WhiteLabels.vue?vue&type=template&id=24d0a15f"
import script from "./WhiteLabels.vue?vue&type=script&lang=js"
export * from "./WhiteLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports